import update from 'immutability-helper';
import { PROGRESS, SUCCESS, FAILED } from "../config/types";
import {
  KEYS_GET_LIST_PROGRESS,
  KEYS_GET_LIST_SUCCESS,
  KEYS_GET_LIST_FAILED,
  KEYS_FORM_SUBMIT_PROGRESS,
  KEYS_FORM_SUBMIT_SUCCESS,
  KEYS_FORM_SUBMIT_FAILED,
  KEYS_GET_KEY_PROGRESS,
  KEYS_GET_KEY_SUCCESS,
  KEYS_GET_KEY_FAILED,
  KEYS_CLEAR_STATE,
} from '../actions/KeysAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
  statistic: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case KEYS_GET_LIST_PROGRESS: {
      return update(
        state, {
          list: { $set: [] },
          pagination: { $set: {} },
          loadListStatus: { $set: PROGRESS },
        },
      );
    }
    case KEYS_GET_LIST_SUCCESS: {
      return update(
        state, {
          list: { $set: action.payload.list },
          pagination: { $set: action.payload.pagination },
          loadListStatus: { $set: SUCCESS },
        },
      );
    }
    case KEYS_GET_LIST_FAILED: {
      return update(
        state, {
          list: { $set: [] },
          pagination: { $set: {} },
          loadListStatus: { $set: FAILED },
        },
      );
    }
    case KEYS_FORM_SUBMIT_PROGRESS: {
      return update(
        state,
        { submitStatus: { $set: PROGRESS } },
      );
    }
    case KEYS_FORM_SUBMIT_SUCCESS: {
      return update(
        state,
        {
          submitStatus: { $set: SUCCESS },
        },
      );
    }
    case KEYS_FORM_SUBMIT_FAILED: {
      return update(
        state,
        { submitStatus: { $set: FAILED } },
      );
    }
    case KEYS_GET_KEY_PROGRESS: {
      return update(
        state, {
          active: { $set: {} },
          statistic: { $set: {} },
          loadActiveStatus: { $set: PROGRESS },
        },
      );
    }
    case KEYS_GET_KEY_SUCCESS: {
      return update(
        state, {
          active: { $set: action.payload.key },
          statistic: { $set: action.payload.statistic || {} },
          loadActiveStatus: { $set: SUCCESS },
        },
      );
    }
    case KEYS_GET_KEY_FAILED: {
      return update(
        state, {
          active: { $set: {} },
          statistic: { $set: {} },
          loadActiveStatus: { $set: FAILED },
        },
      );
    }
    case KEYS_CLEAR_STATE: {
      return update(
        state,
        {
          loadListStatus: { $set: '' },
          loadActiveStatus: { $set: '' },
          submitStatus: { $set: '' },
          list: { $set: [] },
          pagination: { $set: {} },
          active: { $set: {} },
          statistic: { $set: {} },
        },
      );
    }
    default:
      return state;
  }
}
